export const playTimes = [3000, 8000, 13000, 18000, 23000, 50000];
